import { Component, OnInit } from '@angular/core';
import { OutputTag } from '@shared/components/tags';
import { Observable, of } from 'rxjs';
import { ChangeTagsService } from '../change-tags.service';
import { ChangeTagsType } from './change-tags.model';

@Component({
  selector: 'miq-change-tags',
  templateUrl: 'change-tags.component.html',
  styleUrls: ['change-tags.component.scss'],
  standalone: false,
})
export class ChangeTagsComponent implements OnInit {
  private ids = 1;
  private tagsToAdd: Map<number, OutputTag> = new Map<number, OutputTag>();

  public tagsToDelete: string[] = [];
  // This selectedTags is used to reset the tags component when changing the action
  public selectedTags = [];
  public types = ChangeTagsType;
  public selectedChangeType: ChangeTagsType = ChangeTagsType.Add;
  public showAdd = true;
  public showRemove = false;
  public buttonDisabled = true;
  public availableTagsToDelete$: Observable<Array<{ key: string; value: string }>>;

  public filterTags = (filter: string) => {
    return this.changeTagService.onFilterTags(filter);
  };
  public onAddTag = (tag: OutputTag) => {
    return this.addTag(tag);
  };
  public onDeleteTag = (tag: OutputTag) => {
    return this.deleteTag(tag);
  };

  constructor(public changeTagService: ChangeTagsService) {}

  ngOnInit() {
    this.availableTagsToDelete$ = this.changeTagService.getPossibleTagsToDelete();
  }

  public addTag(tag: OutputTag): Observable<number> {
    tag.id = this.ids++;
    this.tagsToAdd.set(tag.id, tag);
    this.checkButtonDisabled();
    return of(tag.id);
  }

  public deleteTag(tag: OutputTag) {
    const wasDeleted = this.tagsToAdd.delete(tag.id);
    this.checkButtonDisabled();
    return of(wasDeleted);
  }

  public typeChanged() {
    this.reset();
    this.showAdd = this.selectedChangeType === ChangeTagsType.Add || this.selectedChangeType === ChangeTagsType.Update;
    this.showRemove =
      this.selectedChangeType === ChangeTagsType.Remove || this.selectedChangeType === ChangeTagsType.Update;
    this.checkButtonDisabled();
    this.selectedTags = [];
  }

  public done() {
    switch (this.selectedChangeType) {
      case ChangeTagsType.Add:
        const tags = Array.from(this.tagsToAdd.values()).map(t => t.name);
        this.changeTagService.executeAddTags(tags);
        break;
      case ChangeTagsType.Remove:
        this.changeTagService.executeRemoveTags(this.tagsToDelete);
        break;
      case ChangeTagsType.Update:
        const toAdd = Array.from(this.tagsToAdd.values()).map(t => t.name);
        this.changeTagService.executeUpdateTags(this.tagsToDelete, toAdd);
        break;
    }
  }

  public deleteTagSelectionChanged() {
    this.checkButtonDisabled();
  }

  private reset() {
    this.tagsToAdd.clear();
    this.tagsToDelete = [];
  }

  private checkButtonDisabled() {
    switch (this.selectedChangeType) {
      case ChangeTagsType.Add:
        this.buttonDisabled = this.tagsToAdd.size <= 0;
        break;
      case ChangeTagsType.Remove:
        this.buttonDisabled = this.tagsToDelete.length <= 0;
        break;
      case ChangeTagsType.Update:
        this.buttonDisabled = this.tagsToAdd.size <= 0 || this.tagsToDelete.length <= 0;
        break;
    }
  }
}
